export default {
  pinInputField: {
    flexGrow: 1,
  },
};
